module.exports = __webpack_public_path__ + "img/carbon_calendar.svg";